// @flow
import * as React from 'react';
import Group from 'sail/Group';
import {BodyAlt} from 'sail/Text';
import {TextInput} from 'sail/Input';

type SetNodeTextProps = {|
  text: string,
  onChange: (any) => void,
  onBlur: (any) => void,
  disabled?: boolean,
|};

export const SetNodeText = ({
  text,
  onChange,
  onBlur,
  disabled,
}: SetNodeTextProps) => (
  <Group spacing={4}>
    <label htmlFor="nodeText">
      <BodyAlt>Text</BodyAlt>
    </label>
    <Group alignItems="center" direction="horizontal" spacing={12}>
      <TextInput
        id="nodeText"
        width="long"
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        value={text}
        placeholder={
          disabled
            ? 'Label is autogenerated for the icon.'
            : 'Enter text to be display inside the node.'
        }
      />
    </Group>
  </Group>
);
